import { useLocation, useParams } from 'react-router-dom';
import { Box, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import Assignment from '@mui/icons-material/Assignment';
import TramiteDetalle from './TramiteDetalle';
import TramiteLista from './TramiteLista';
import TramiteNuevo from './TramiteNuevo';

/**
 * Bandeja de trámites del afiliado: lista a la izquierda y detalle a la derecha.
 * En pantallas chicas se muestra una cosa por vez: la lista, o el detalle / el formulario con "Volver".
 * Rutas: /tramites, /tramites/nuevo, /tramites/:id
 */
export default function Tramites() {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  const { id } = useParams();
  const { pathname } = useLocation();
  const esNuevo = pathname === '/tramites/nuevo';
  const hayDetalle = esNuevo || !!id;

  const mostrarLista = desktop || !hayDetalle;
  const mostrarDetalle = desktop || hayDetalle;

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
        Trámites con el gremio
      </Typography>
      <Box sx={{ display: 'grid', gap: 2, alignItems: 'start', gridTemplateColumns: desktop ? 'minmax(300px, 2fr) 3fr' : '1fr' }}>
        {mostrarLista && <TramiteLista selectedId={id} nuevoActivo={esNuevo} />}
        {mostrarDetalle && (
          <Box sx={{ minWidth: 0 }}>
            {esNuevo ? (
              <TramiteNuevo mostrarVolver={!desktop} />
            ) : id ? (
              <TramiteDetalle key={id} id={id} mostrarVolver={!desktop} />
            ) : (
              <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
                <Assignment sx={{ fontSize: 40, mb: 1 }} />
                <Typography>Elegí un trámite de la lista para ver el detalle, o iniciá uno nuevo.</Typography>
              </Paper>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}
